import type { Action } from 'redux';
import dashboard from './modules/dashboard/dashboardReducer';
import email from './modules/email/emailReducer';
import emailOnboarding from './modules/emailOnboarding/emailOnboardingReducer';
import report from './modules/report/reportReducer';
import search from './modules/search/searchReducer';
import user from './modules/user/userReducer';
import demandReports from './modules/demandReports/demandReportsReducer';
import company from './modules/company/companyReducer';
import { UserActionTypes as userTypes } from './modules/user/userTypes';

const appReducer = (state: any = {}, action: Action) => {
	return {
		user: user(state?.user, action),
		dashboard: dashboard(state?.dashboard, action),
		demandReports: demandReports(state?.demandReports, action),
		report: report(state?.report, action),
		search: search(state?.search, action),
		email: email(state?.email, action, state),
		emailOnboarding: emailOnboarding(state?.emailOnboarding, action, state),
		company: company(state?.company, action)
	};
};

const rootReducer = (state: any, action: any): any => {
	if (action.type === userTypes.USER_LOGOUT_REQUEST) {
		// eslint-disable-next-line no-param-reassign
		state = undefined;
	}

	return appReducer(state, action);
};

export type RootState = ReturnType<typeof appReducer>;

export default rootReducer;
